import React from 'react';
import { podeGerenciar, nomeAmigavel } from '../../../utils/cargos';

/**
 * Componente de apresentação da tabela de usuários
 * Exibe loading, error, empty state ou tabela com usuários
 * 
 * @param {Object} props
 * @param {Array} props.usuarios - Lista de usuários
 * @param {boolean} props.loading - Estado de carregamento
 * @param {string|null} props.error - Mensagem de erro
 * @param {Object} props.user - Usuário logado (para validar permissões)
 * @param {Function} props.onEdit - Callback ao clicar em editar
 * @param {Function} props.onDelete - Callback ao clicar em deletar
 * @param {Function} props.onRetry - Callback ao clicar em tentar novamente
 */
const UsuariosTable = ({ 
  usuarios, 
  loading, 
  error, 
  user,
  onEdit, 
  onDelete,
  onRetry
}) => {
  // Loading state
  if (loading) {
    return <div className="usuarios-loading">Carregando usuários...</div>;
  }
  
  // Error state
  if (error) {
    return (
      <div className="usuarios-error">
        <h3>Erro ao carregar</h3>
        <p>{error}</p>
        <button className="usuarios-btn-retry" onClick={onRetry}>
          Tentar novamente
        </button>
      </div>
    );
  }
  
  // Empty state
  if (usuarios.length === 0) {
    return (
      <div className="usuarios-empty-state">
        <p>Nenhum usuário encontrado para este condomínio.</p>
      </div>
    );
  }
  
  // Table with data
  return (
    <div className="usuarios-table-wrapper">
      <table className="usuarios-table">
        <thead>
          <tr>
            <th>Usuário</th>
            <th>Cargo</th>
            <th>Condomínios</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {usuarios.map((usuario) => {
            const podeEditar = podeGerenciar(user.cargo, usuario.cargo);
            const podeDeletar = podeEditar && usuario.id !== user.id;
            
            return (
              <tr key={usuario.id}>
                <td>{usuario.username}</td>
                <td>
                  <span className={`usuarios-cargo-badge usuarios-cargo-${usuario.cargo}`}>
                    {nomeAmigavel(usuario.cargo)}
                  </span>
                </td>
                <td className="usuarios-td-condominios">
                  {usuario.cargo === 'admin' ? (
                    <span className="usuarios-all-access">Todos os condomínios</span>
                  ) : (
                    usuario.condominios_nomes?.join(', ') || '-'
                  )}
                </td>
                <td className="usuarios-td-acoes">
                  <button 
                    className="usuarios-btn-edit" 
                    onClick={() => onEdit(usuario)}
                    disabled={!podeEditar}
                    title={!podeEditar ? "Sem permissão" : "Editar"}
                  >
                    ✏️
                  </button>
                  <button 
                    className="usuarios-btn-delete" 
                    onClick={() => onDelete(usuario)}
                    disabled={!podeDeletar}
                    title={
                      usuario.id === user.id 
                        ? "Não pode excluir a si mesmo" 
                        : !podeEditar 
                          ? "Sem permissão" 
                          : "Excluir"
                    }
                  >
                    🗑️
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default UsuariosTable;
